import {initRewardsCatalogueFilter} from "../components/rewards/rewardsCatalogueFilter.client";

initRewardsCatalogueFilter();
